import axios from 'axios';
import Toast from '@/components/message/Toast';
import { getSessionStorage } from '../../utils/stage';

// create an axios instance
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
	// 'Content-Type': 'application/json',
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 5000, // request timeout
});

// request interceptor
service.interceptors.request.use(
	(config) => {
		// do something before request is sent
		return config;
	},
	(error) => {
		// do something with request error
		console.log(error); // for debug
		return Promise.reject(error);
	}
);

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom errcode
	 * Here is just an example
	 * You can also judge the status by HTTP Status errcode
	 */
	(response) => {
		const res = response.data;

		// if the custom errcode is not 20000, it is judged as an error.
		if (
			res.errcode !== 0 &&
			res.errcode !== 3 &&
			res.errcode !== 503 &&
			res.errcode !== 504 &&
			res.errcode !== 506 &&
			res.errcode !== 509
		) {
			Toast(res.errmsg);
			return Promise.reject(new Error(res.errmsg || 'Error'));
		} else {
			return res;
		}
	},
	(error) => {
		const title = JSON.parse(getSessionStorage('lang1'));
		if (error.message.indexOf('5000ms') > -1) {
			Toast(title.netError);
		} else if (
			error.message.indexOf('Network Error') > -1 ||
			error.message.indexOf('Network') > -1
		) {
			Toast(title.netError);
		} else {
			console.log(error);
		}
		console.log(error.message);
		// for debug
		return Promise.reject(error);
	}
);

export default service;
